import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { saveAttorney } from "../lib/attorneyAuth";
import { BrandMark } from "../components/Brand";
import { Loader2 } from "lucide-react";

/**
 * Handles the Emergent Google OAuth redirect. Reads `session_id` from the URL
 * fragment, exchanges it via /api/attorney/auth/session, then routes to the portal.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/attorney-login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/attorney/auth/session", { session_id });
        saveAttorney(data);
        // Strip the hash and navigate cleanly
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/attorney/portal", { replace: true });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F9FC]" data-testid="auth-callback">
      <div className="bg-white border border-[#E5E7EB] rounded-2xl px-10 py-12 max-w-md text-center shadow-sm">
        <BrandMark />
        <div className="mt-8 flex items-center justify-center text-[#0066FF]">
          <Loader2 className="w-6 h-6 animate-spin" />
        </div>
        <h2 className="font-display text-xl text-[#0A2540] font-semibold mt-5">Signing you in…</h2>
        <p className="text-sm text-[#6B7280] mt-2">Verifying your Google session and opening your attorney portal.</p>
        {error && (
          <div className="mt-5 text-sm text-[#B91C1C]" data-testid="auth-callback-error">
            {error}
            <button
              onClick={() => navigate("/attorney-login", { replace: true })}
              className="block mx-auto mt-3 underline text-[#0066FF]"
            >Back to sign in</button>
          </div>
        )}
      </div>
    </div>
  );
}
